import type { CrmMessages } from "./englishCrmMessages";

export const russianCrmMessages = {
  resources: {
    companies: {
      name: "Компания |||| Компании",
      forcedCaseName: "Компания",
      fields: {
        name: "Название компании",
        website: "Сайт",
        linkedin_url: "LinkedIn",
        phone_number: "Телефон",
        created_at: "Создано",
        nb_contacts: "Число контактов",
        revenue: "Выручка",
        sector: "Отрасль",
        size: "Размер",
        tax_identifier: "Идентификатор (ИНН и т.п.)",
        tax_identifier_short: "ИНН",
        address: "Адрес",
        city: "Город",
        zipcode: "Индекс",
        state_abbr: "Регион",
        country: "Страна",
        description: "Описание",
        context_links: "Ссылки для контекста",
        sales_id: "Ответственный менеджер",
        ornz: "ОРНЗ",
        ogrn: "ОГРН",
        research_email: "Email из исследования",
        lead_priority: "Приоритет продаж",
        lead_priority_rank: "Приоритет продаж",
        lead_score: "Оценка лида",
        decision_maker: "ЛПР",
        decision_maker_role: "Роль ЛПР",
        decision_maker_profile_url: "Профиль ЛПР",
        website_status: "Статус сайта",
        digital_maturity_score: "Цифровая зрелость",
        specializations: "Специализации",
        social_profile_count: "Профили в соцсетях",
        has_vacancy_signal: "Есть кадровый сигнал",
        vacancy_freshness: "Свежесть вакансий",
        has_cases_clients: "Есть кейсы или клиенты",
        personalized_reason: "Персонализированный повод",
        research_checked_at: "Дата исследования",
        research_source_urls: "Источники исследования",
        revenue_2025_thousand_rub: "Выручка за 2025 год, тыс. ₽",
        marketing_consent_status: "Статус согласия на рекламу",
        marketing_consent_channel: "Канал согласия",
        marketing_consent_granted_at: "Дата и время согласия",
        marketing_consent_evidence_url: "Ссылка на доказательство согласия",
        do_not_contact: "Не связываться",
        sro_membership_status: "Статус членства в СРО",
        sro_membership_ended_at: "Дата прекращения членства",
        sro_membership_end_reason: "Основание прекращения членства",
        sro_membership_checked_at: "Дата проверки членства",
      },
      empty: {
        description: "Список компаний пуст.",
        title: "Компании не найдены",
      },
      field_categories: {
        contact: "Контакты",
        additional_info: "Дополнительно",
        address: "Адрес",
        context: "Контекст",
        sales_intelligence: "Данные для продажи",
        contact_permission: "Разрешение на контакт",
      },
      action: {
        create: "Создать компанию",
        edit: "Редактировать компанию",
        new: "Новая компания",
        show: "Просмотр компании",
      },
      added_on: "Добавлено %{date}",
      followed_by: "Закреплено за %{name}",
      followed_by_you: "Закреплено за вами",
      no_contacts: "Нет контактов",
      nb_contacts: "%{smart_count} контакт |||| %{smart_count} контактов",
      nb_deals: "%{smart_count} сделка |||| %{smart_count} сделок",
      auditors_count_value:
        "%{smart_count} аудитор |||| %{smart_count} аудиторов",
      priority: {
        high: "Высокий",
        medium: "Средний",
        low: "Низкий",
      },
      sro_membership: {
        active: "Членство действует",
        ceased: "Членство прекращено",
      },
      consent_status: {
        unknown: "Согласие не подтверждено",
        requested: "Согласие запрошено",
        granted: "Согласие подтверждено",
        revoked: "Согласие отозвано",
        stop_list: "Стоп-лист",
      },
      consent_channel: {
        phone: "Телефон",
        email: "Email",
        messenger: "Мессенджер",
        form: "Форма на сайте",
        event: "Мероприятие",
        referral: "Рекомендация",
        contract: "Договор",
        not_set: "Канал не указан",
      },
      digital_maturity: {
        high: "Высокая: 8–10",
        medium: "Средняя: 5–7",
        low: "Низкая: 0–4",
      },
      sales: {
        score: "Score %{score}",
        digital_maturity: "Цифровая зрелость %{score}/10",
        social_profiles:
          "%{smart_count} профиль в соцсетях |||| %{smart_count} профилей в соцсетях",
        has_cases_clients: "Есть кейсы/клиенты",
        has_vacancy_signal: "Есть кадровый сигнал",
        more_specializations: "+%{smart_count}",
        research_checked_at: "Исследование проверено: %{date}",
        sources: "%{smart_count} источник |||| %{smart_count} источников",
        public_contact_notice:
          "Публичный контакт не является согласием на рекламное обращение.",
        sro_membership_ceased:
          "Фирма исключена из активной очереди продаж: членство в СРО прекращено.",
      },
      sizes: {
        one_to_three_active_auditors: "1-3",
        four_to_ten_active_auditors: "4-10",
        eleven_to_twenty_five_active_auditors: "11-25",
        twenty_six_to_fifty_active_auditors: "26-50",
        more_than_fifty_active_auditors: "50+",
      },
      autocomplete: {
        create_error: "Ошибка при создании компании",
        create_item: "Создать %{item}",
        create_label: "Начните вводить, чтобы создать компанию",
      },
      filters: {
        auditors_count: "Количество аудиторов",
        all_cities: "Все города",
        all_managers: "Все сотрудники",
        all_regions: "Все регионы",
        city_region: "Город/регион",
        no_regions: "Регионы не найдены",
        only_mine: "Только мои компании",
        search: "Поиск компаний",
        search_city: "Найти город",
        search_region: "Найти регион",
        sales_priority: "Приоритет продаж",
        specialization: "Специализация",
        all_specializations: "Все специализации",
        sales_signals: "Сигналы продаж",
        with_social_profiles: "Есть соцсети",
        with_cases_clients: "Есть кейсы/клиенты",
        with_vacancy_signal: "Есть кадровый сигнал",
        with_reachable_website: "Сайт доступен",
        digital_maturity: "Цифровая зрелость",
        contact_permission: "Разрешение на контакт",
        sro_membership_status: "Статус членства в СРО",
      },
      import: {
        title: "Импорт компаний",
        button: "Импорт CSV",
        complete:
          "Импорт завершён. Обработано строк: %{importCount}, ошибок: %{errorCount}.",
        progress:
          "Импортировано %{importCount} из %{rowCount} компаний, ошибок: %{errorCount}.",
        error:
          "Не удалось импортировать файл. Убедитесь, что это корректный CSV.",
        remaining_time: "Ориентировочно осталось:",
        running: "Идёт импорт, не закрывайте вкладку.",
        sample_download: "Скачать пример CSV",
        sample_hint:
          "Используйте пример как шаблон колонок. Существующие компании обновляются по ИНН или точному названию; новые создаются.",
        stop: "Остановить импорт",
        csv_file: "Файл CSV",
      },
    },
    audit_research_directory: {
      name: "Запись исследования |||| Каталог исследования",
      nav: "Исследование",
      title: "Аудиторы, эксперты и профессиональные сообщества",
      company_section: "Аудиторы и публичные каналы",
      company_social:
        "%{smart_count} публичный канал |||| %{smart_count} публичных каналов",
      company_auditors: "%{smart_count} аудитор |||| %{smart_count} аудиторов",
      ceased_company_people_notice:
        "Персональный состав сохранён как историческая запись; текущая занятость не подтверждается после прекращения членства фирмы в СРО.",
      view_company_entries:
        "Открыть %{smart_count} запись |||| Открыть все %{smart_count} записей",
      open: "Открыть профиль",
      source: "Источник",
      fields: {
        record_kind: "Категория",
        name: "Человек или канал",
        company_name: "Компания",
        company_ornz: "ОРНЗ компании",
        role_or_audience: "Роль или аудитория",
        person_ornz: "ОРНЗ человека",
        certificate_number: "Аттестат",
        employment_type: "Тип занятости",
        platform: "Площадка",
        contact_url: "Публичный профиль",
        source_url: "Источник подтверждения",
        source_type: "Тип источника",
        confidence: "Достоверность",
        checked_at: "Дата проверки",
      },
      kinds: {
        manager: "Руководитель",
        auditor: "Аудитор",
        expert: "Эксперт",
        company_social: "Канал компании",
        expert_social: "Канал эксперта",
        community: "Сообщество",
      },
      confidence: {
        high: "Высокая достоверность",
        medium: "Средняя достоверность",
        low: "Низкая достоверность",
      },
      employment: {
        primary: "Основное место",
        part_time: "Совместительство",
      },
    },
    company_interactions: {
      name: "Взаимодействие |||| Взаимодействия",
      title: "Взаимодействия",
      subtitle:
        "Звонки, презентации, демо, договоры, счета, поддержка и допродажи.",
      tab: "Взаимодействия",
      empty: "Взаимодействий пока нет.",
      load_error: "Не удалось загрузить взаимодействия.",
      created: "Взаимодействие добавлено",
      action: {
        add: "Добавить",
        add_report: "Оставить отчет",
        save_report: "Сохранить отчет",
      },
      dialog: {
        create_for: "Добавить взаимодействие: %{name}",
        report_for: "Отчет по компании",
      },
      overview: {
        stage: "Этап",
        latest: "Последнее касание",
        next_step: "Следующий шаг",
        status: "Статус",
        no_deal: "Сделки нет",
        no_interactions: "Касаний нет",
        no_next_step: "Следующий шаг не задан",
        overdue: "Просрочено",
        on_track: "В работе",
        has_next_step: "Следующее действие запланировано",
      },
      linked: {
        contact: "Контакт: %{name}",
        deal: "Сделка: %{name}",
      },
      fields: {
        company_id: "Компания",
        contact_id: "Контакт",
        deal_id: "Сделка",
        type: "Тип",
        interaction_date: "Дата",
        summary: "Что произошло",
        result: "Результат",
        next_step: "Следующий шаг",
        next_step_date: "Дата следующего шага",
        sales_id: "Ответственный менеджер",
      },
      types: {
        call: "Звонок",
        message: "Сообщение",
        email: "Письмо",
        meeting: "Встреча",
        presentation_sent: "Презентация отправлена",
        demo_scheduled: "Демо запланировано",
        demo_done: "Демо проведено",
        contract_preparation: "Подготовка договора",
        invoice_sent: "Счет выставлен",
        payment_received: "Оплата получена",
        implementation: "Внедрение",
        support: "Поддержка",
        feature_presentation: "Презентация нового функционала",
        upsell: "Допродажа",
      },
    },
    contacts: {
      name: "Контакт |||| Контакты",
      forcedCaseName: "Контакт",
      field_categories: {
        background_info: "Дополнительно",
        identity: "Личные данные",
        misc: "Прочее",
        personal_info: "Контакты",
        position: "Должность",
      },
      fields: {
        first_name: "Имя",
        last_name: "Фамилия",
        last_seen: "Последняя активность",
        title: "Должность",
        company_id: "Компания",
        email_jsonb: "Адреса email",
        email: "Email",
        phone_jsonb: "Телефоны",
        phone_number: "Телефон",
        linkedin_url: "URL LinkedIn",
        background: "Контекст (биография, как познакомились и т.д.)",
        has_newsletter: "Подписка на рассылку",
        sales_id: "Ответственный менеджер",
      },
      action: {
        add: "Добавить контакт",
        add_first: "Добавьте первый контакт",
        create: "Создать контакт",
        edit: "Редактировать контакт",
        export_vcard: "Экспорт в vCard",
        new: "Новый контакт",
        show: "Просмотр контакта",
      },
      background: {
        last_activity_on: "Последняя активность %{date}",
        added_on: "Добавлен %{date}",
        followed_by: "Ведёт %{name}",
        followed_by_you: "Ведёте вы",
        status_none: "Нет",
      },
      position_at: "%{title} в",
      position_at_company: "%{title} в %{company}",
      empty: {
        description: "Список контактов пуст.",
        title: "Контакты не найдены",
      },
      import: {
        title: "Импорт контактов",
        button: "Импорт CSV",
        complete:
          "Импорт завершён. Импортировано контактов: %{importCount}, ошибок: %{errorCount}",
        progress:
          "Импортировано %{importCount} из %{rowCount} контактов, ошибок: %{errorCount}.",
        error:
          "Не удалось импортировать файл. Убедитесь, что это корректный CSV.",
        imported: "Импортировано",
        remaining_time: "Ориентировочно осталось:",
        running: "Идёт импорт, не закрывайте вкладку.",
        sample_download: "Скачать пример CSV",
        sample_hint: "Пример CSV можно использовать как шаблон",
        stop: "Остановить импорт",
        csv_file: "Файл CSV",
        contacts_label: "контакт |||| контактов",
      },
      inputs: {
        genders: {
          male: "Он / его",
          female: "Она / её",
          nonbinary: "Они / их",
        },
        personal_info_types: {
          work: "Рабочий",
          home: "Домашний",
          other: "Другой",
        },
      },
      list: {
        error_loading: "Ошибка загрузки контактов",
      },
      bulk_tag: {
        action: "Тег",
        back: "К тегам",
        create_description:
          "Создайте новый тег и назначьте выбранным контактам.",
        description:
          "Выберите существующий тег или создайте новый для выбранных контактов.",
        empty: "Тегов пока нет. Создайте тег для выбранных контактов.",
        error: "Не удалось добавить тег контактам",
        noop: "У выбранных контактов уже есть этот тег",
        success:
          "Тег добавлен к %{smart_count} контакту |||| Тег добавлен к %{smart_count} контактам",
        title: "Добавить тег контактам",
      },
      merge: {
        action: "Объединить с другим контактом",
        confirm: "Объединить контакты",
        current_contact: "Текущий контакт (будет удалён)",
        description: "Объединить этого контакта с другим.",
        error: "Не удалось объединить контакты",
        merging: "Объединение…",
        no_additional_data: "Нет дополнительных данных для слияния",
        select_target: "Выберите контакт для объединения",
        success: "Контакты успешно объединены",
        target_contact: "Целевой контакт (будет сохранён)",
        title: "Объединение контактов",
        warning_description:
          "Все данные перейдут ко второму контакту. Отменить нельзя.",
        warning_title: "Внимание: необратимая операция",
        what_will_be_merged: "Что будет объединено:",
      },
      filters: {
        before_last_month: "До прошлого месяца",
        before_this_month: "До этого месяца",
        before_this_week: "До этой недели",
        managed_by_me: "Закреплены за мной",
        search: "Поиск по имени, компании…",
        this_week: "Эта неделя",
        today: "Сегодня",
        tags: "Теги",
        tasks: "Задачи",
      },
      hot: {
        empty_change_status:
          "Измените статус контакта: добавьте заметку и откройте «показать опции».",
        empty_hint: "Контакты со статусом «горячий» появятся здесь.",
        title: "Горячие контакты",
      },
    },
    deals: {
      name: "Сделка |||| Сделки",
      fields: {
        name: "Название",
        description: "Описание",
        company_id: "Компания",
        contact_ids: "Контакты",
        category: "Категория",
        amount: "Бюджет",
        expected_closing_date: "Ожидаемая дата закрытия",
        stage: "Этап",
      },
      action: {
        back_to_deal: "К сделке",
        create: "Создать сделку",
        new: "Новая сделка",
      },
      field_categories: {
        misc: "Прочее",
      },
      archived: {
        action: "В архив",
        error: "Ошибка: сделка не архивирована",
        list_title: "Архив сделок",
        success: "Сделка в архиве",
        title: "Архивная сделка",
        view: "Показать архив",
      },
      inputs: {
        linked_to: "Связано с",
      },
      unarchived: {
        action: "Вернуть на доску",
        error: "Ошибка: не удалось восстановить сделку",
        success: "Сделка восстановлена из архива",
      },
      updated: "Сделка обновлена",
      empty: {
        before_create: "перед созданием сделки.",
        description: "Список сделок пуст.",
        title: "Сделки не найдены",
      },
      invalid_date: "Некорректная дата",
    },
    notes: {
      name: "Заметка |||| Заметки",
      forcedCaseName: "Заметка",
      fields: {
        status: "Статус",
        date: "Дата",
        attachments: "Вложения",
        contact_id: "Контакт",
        deal_id: "Сделка",
      },
      action: {
        add: "Добавить заметку",
        add_first: "Добавьте первую заметку",
        delete: "Удалить заметку",
        edit: "Редактировать заметку",
        update: "Обновить заметку",
        add_this: "Добавить эту заметку",
      },
      sheet: {
        create: "Создать заметку",
        create_for: "Заметка для %{name}",
        edit: "Редактировать заметку",
        edit_for: "Редактировать заметку для %{name}",
      },
      deleted: "Заметка удалена",
      empty: "Заметок пока нет",
      author_added: "%{name} добавил(а) заметку",
      you_added: "Вы добавили заметку",
      me: "Я",
      list: {
        error_loading: "Ошибка загрузки заметок",
      },
      note_for_contact: "Заметка для %{name}",
      stepper: {
        hint: "Откройте страницу контакта и добавьте заметку",
      },
      added: "Заметка добавлена",
      inputs: {
        add_note: "Добавить заметку",
        options_hint: "(вложения или изменить детали)",
        show_options: "Показать опции",
      },
      actions: {
        attach_document: "Прикрепить файл",
      },
      validation: {
        note_or_attachment_required: "Нужен текст заметки или вложение",
      },
      editor: {
        slash_hint: "Блоки",
        commands: {
          paragraph: "Текст",
          heading_1: "Заголовок 1",
          heading_2: "Заголовок 2",
          bullet_list: "Маркированный список",
          ordered_list: "Нумерованный список",
          quote: "Цитата",
          code: "Код",
          divider: "Разделитель",
        },
        command_descriptions: {
          paragraph: "Обычный абзац",
          heading_1: "Крупный заголовок раздела",
          heading_2: "Средний заголовок раздела",
          bullet_list: "Список с маркерами",
          ordered_list: "Список с номерами",
          quote: "Выделить важный фрагмент",
          code: "Моноширинный блок",
          divider: "Разделить части заметки",
        },
      },
    },
    sales: {
      name: "Пользователь |||| Пользователи",
      fields: {
        first_name: "Имя",
        last_name: "Фамилия",
        email: "Email",
        administrator: "Админ",
        disabled: "Отключён",
      },
      create: {
        error: "Ошибка при создании пользователя.",
        success: "Пользователь создан. Ему на почту придёт ссылка для пароля.",
        title: "Создать пользователя",
      },
      edit: {
        error: "Ошибка. Попробуйте снова.",
        record_not_found: "Запись не найдена",
        success: "Пользователь обновлён",
        title: "Редактировать %{name}",
      },
      action: {
        new: "Новый пользователь",
      },
    },
    tasks: {
      name: "Задача |||| Задачи",
      forcedCaseName: "Задача",
      fields: {
        text: "Описание",
        due_date: "Срок",
        type: "Тип",
        contact_id: "Контакт",
        due_short: "срок",
      },
      action: {
        add: "Добавить задачу",
        create: "Создать задачу",
        edit: "Редактировать задачу",
      },
      actions: {
        postpone_next_week: "Перенести на следующую неделю",
        postpone_tomorrow: "Перенести на завтра",
        title: "Действия с задачей",
      },
      added: "Задача добавлена",
      deleted: "Задача удалена",
      dialog: {
        create: "Создать задачу",
        create_for: "Задача для %{name}",
      },
      sheet: {
        edit: "Редактировать задачу",
        edit_for: "Редактировать задачу для %{name}",
      },
      empty: "Задач пока нет",
      empty_list_hint: "Задачи у контактов появятся здесь.",
      filters: {
        later: "Позже",
        overdue: "Просрочено",
        this_week: "Эта неделя",
        today: "Сегодня",
        tomorrow: "Завтра",
        with_pending: "С невыполненными задачами",
      },
      regarding_contact: "(По %{name})",
      updated: "Задача обновлена",
    },
    tags: {
      name: "Тег |||| Теги",
      action: {
        add: "Добавить тег",
        create: "Создать тег",
      },
      dialog: {
        color: "Цвет",
        create_title: "Новый тег",
        edit_title: "Редактировать тег",
        name_label: "Название тега",
        name_placeholder: "Введите название",
      },
    },
  },
  crm: {
    action: {
      reset_password: "Сбросить пароль",
    },
    auth: {
      first_name: "Имя",
      last_name: "Фамилия",
      confirm_password: "Подтверждение пароля",
      confirmation_required: "Подтвердите аккаунт по ссылке из письма.",
      recovery_email_sent:
        "Если вы зарегистрированы, скоро придёт письмо для сброса пароля.",
      sign_in_failed: "Не удалось войти.",
      sign_in_google_workspace: "Войти через Google Workspace",
      signup: {
        create_account: "Создать аккаунт",
        create_first_user:
          "Создайте первого пользователя, чтобы завершить настройку.",
        creating: "Создание…",
        initial_user_created: "Первый пользователь создан",
      },
      welcome_title: "Добро пожаловать в Atomic CRM",
    },
    common: {
      activity: "Активность",
      added: "добавил(а)",
      details: "Подробности",
      last_activity_with_date: "последняя активность %{date}",
      load_more: "Загрузить ещё",
      misc: "Прочее",
      past: "Прошлое",
      read_more: "Читать далее",
      retry: "Повторить",
      show_less: "Свернуть",
      task_count: "%{smart_count} задача |||| %{smart_count} задач",
      copied: "Скопировано!",
      copy: "Копировать",
      loading: "Загрузка…",
      me: "Я",
    },
    activity: {
      added_company: "%{name} добавил(а) компанию",
      you_added_company: "Вы добавили компанию",
      added_contact: "%{name} добавил(а) контакт",
      you_added_contact: "Вы добавили контакт",
      added_note: "%{name} добавил(а) заметку о",
      you_added_note: "Вы добавили заметку о",
      added_note_about_deal: "%{name} добавил(а) заметку о сделке",
      you_added_note_about_deal: "Вы добавили заметку о сделке",
      added_deal: "%{name} добавил(а) сделку",
      you_added_deal: "Вы добавили сделку",
      at_company: "в",
      to: "к",
      load_more: "Загрузить ещё активность",
    },
    dashboard: {
      deals_chart: "Выручка по сделкам",
      deals_pipeline: "Воронка сделок",
      latest_activity: "Последняя активность",
      latest_activity_error: "Ошибка загрузки активности",
      latest_notes: "Мои последние заметки",
      latest_notes_added_ago: "добавлено %{timeAgo}",
      stepper: {
        install: "Установите Atomic CRM",
        progress: "Сделано %{step} из 3",
        whats_next: "Что дальше?",
      },
      upcoming_tasks: "Предстоящие задачи",
    },
    header: {
      import_data: "Импорт данных",
    },
    image_editor: {
      change: "Заменить",
      drop_hint: "Перетащите файл или нажмите для выбора.",
      editable_content: "Редактируемое содержимое",
      title: "Загрузка и обрезка изображения",
      update_image: "Обновить изображение",
    },
    import: {
      action: {
        download_error_report: "Скачать отчёт об ошибках",
        import: "Импорт",
        import_another: "Импортировать другой файл",
      },
      error: {
        unable: "Не удалось импортировать файл.",
      },
      idle: {
        description_1:
          "Можно импортировать пользователей, компании, контакты, заметки и задачи.",
        description_2: "Данные в файле JSON по образцу:",
      },
      status: {
        all_success: "Все записи импортированы.",
        complete: "Импорт завершён.",
        failed: "Ошибка",
        imported: "Импортировано",
        in_progress: "Идёт импорт, не покидайте страницу.",
        some_failed: "Часть записей не импортирована.",
        table_caption: "Статус импорта",
      },
      title: "Импорт данных",
    },
    settings: {
      companies: {
        sectors: "Отрасли",
      },
      dark_mode_logo: "Логотип (тёмная тема)",
      deals: {
        categories: "Категории",
        currency: "Валюта",
        pipeline_help: "Какие этапы сделок считать активными в воронке.",
        pipeline_statuses: "Статусы воронки",
        stages: "Этапы",
      },
      light_mode_logo: "Логотип (светлая тема)",
      notes: {
        statuses: "Статусы заметок",
      },
      reset_defaults: "Сбросить к умолчанию",
      save_error: "Не удалось сохранить настройки",
      saved: "Настройки сохранены",
      saving: "Сохранение…",
      tasks: {
        types: "Типы задач",
      },
      preferences: "Предпочтения",
      title: "Настройки",
      app_title: "Название приложения",
      sections: {
        branding: "Оформление",
      },
      validation: {
        duplicate: "Дубликат %{display_name}: %{items}",
        in_use:
          "Нельзя удалить %{display_name}, используется в сделках: %{items}",
        validating: "Проверка…",
        entities: {
          categories: "категории",
          stages: "этапы",
        },
      },
    },
    theme: {
      dark: "Тёмная",
      label: "Тема",
      light: "Светлая",
      system: "Как в системе",
    },
    language: "Язык",
    navigation: {
      label: "Навигация CRM",
    },
    mobile_navigation: {
      more: "Ещё",
    },
    knowledge_base: {
      articles_count: "материала",
      back_to_index: "База знаний",
      description:
        "Продуктовые и бизнес-материалы Doka: стратегия, планирование, анализ конкурентов и внутренняя методология.",
      open_article: "Открыть",
      section_label: "Внутренние материалы",
      title: "База знаний",
      updated: "Обновлено",
    },
    mail: {
      tab: "Почта",
      account: {
        title: "Почта IMAP/SMTP",
        description:
          "Подключите почтовый ящик по IMAP и SMTP, чтобы получать и отправлять письма из CRM.",
        connect: "Подключить почту",
        connected: "Почта подключена",
        disconnected: "Почтовый ящик отключён",
      },
      sync: {
        complete: "Синхронизация завершена: %{count} новых писем",
      },
    },
    profile: {
      inbound: {
        description:
          "Отправляйте письма на inbound-адрес сервера (например в поле %{field}). Atomic CRM обработает письма и добавит заметки к контактам.",
        title: "Входящая почта",
      },
      mcp: {
        title: "Сервер MCP",
        description:
          "URL для подключения ИИ-клиента к CRM через Model Context Protocol (MCP).",
        tokens: {
          title: "Персональные токены доступа",
          description:
            "Выпустите отзывной токен для MCP-клиента. Он получает те же права в CRM, что и ваш аккаунт.",
          name: "Название токена",
          name_placeholder: "Например, Codex на Mac",
          expires: "Срок действия",
          days: "%{days} дней",
          create: "Выпустить",
          created: "MCP-токен выпущен",
          copy_now: "Скопируйте токен сейчас",
          shown_once:
            "После закрытия этого сообщения токен больше не покажется.",
          empty: "У вас пока нет персональных MCP-токенов.",
          load_error: "Не удалось загрузить MCP-токены.",
          expires_at: "Действует до %{date}",
          last_used: "Использован %{date}",
          revoke: "Отозвать токен",
          revoke_confirm:
            "Отозвать токен «%{name}»? Это действие нельзя отменить.",
          revoked: "MCP-токен отозван",
          status: {
            active: "Активен",
            expired: "Истёк",
            revoked: "Отозван",
          },
        },
      },
      password: {
        change: "Сменить пароль",
      },
      password_reset_sent: "Письмо для сброса пароля отправлено на ваш email",
      record_not_found: "Запись не найдена",
      title: "Профиль",
      updated: "Профиль обновлён",
      update_error: "Ошибка. Попробуйте снова",
    },
    validation: {
      invalid_url: "Должен быть корректный URL",
      invalid_linkedin_url: "URL должен быть с домена linkedin.com",
    },
  },
} satisfies CrmMessages;
